<template>
    <div class="wrapper">
      <item-detail v-if="detail.is_file !='1'" :detail="detail"></item-detail>
      <file-down v-if="detail.is_file =='1'" :detail="detail"></file-down>
    </div>
</template>
<script>
import { userApi } from "@/api/user.js";
import { mapActions, mapGetters } from "vuex";
import itemDetail from "@/components/common/itemDetail.vue";
import fileDown from "@/components/common/fileDown.vue";
export default {
  data() {
    return {
      detail: {},
    };
  },
  methods: {
      ...mapActions(['firstTitle','secondTitle']),
    getDetail() {
      userApi.workDetail({ id: this.$route.query.id }).then(res => {
        this.detail = res.data;
        this.secondTitle(this.detail.workname)
      });
    }
  },
  mounted() {
    if (this.$route.query.type == 1) {
      this.firstTitle("海洋标准化");
    } else if (this.$route.query.type == 2) {
      this.firstTitle("海洋计量");
    } else if (this.$route.query.type == 3) {
      this.firstTitle("海洋质量监督");
    }
    this.getDetail();
  },
  watch: {
    $route(val, oldval) {
      this.getDetail();
    }
  },
    components: {
    itemDetail,
    fileDown
  }
};
</script>
<style lang="less" scoped>
@import "./../../../common/minix.less";
.wrapper{
   width: 100%;
  padding: 20/@rem;
  box-sizing: border-box;
  background: #F2F2F2;
}
</style>


// WEBPACK FOOTER //
// src/components/businessWork/Children/detail.vue